import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable, catchError, of, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ScoreService {

  constructor(private http: HttpClient) { }

  // v1.0/score?apexid=zhangw13&kpidate=2024-02
  getScoreByApexIdAndMonth(apexId:string, month:string): Observable<any[]> {
    
    // let url=`${environment.api.uri}v1.0/coaching`;
    let url=`${environment.api.uri}v1.0/score?apexid=${apexId}&kpidate=${month}`;
    return this.http.get<any[]>(url);
  }

  // v1.0/score?apexid=zhangw13&businesstype=PG&country=CN&kpidate=2024-02-01&timerange=month
  // v1.0/score?apexid=zhangw13&businesstype=PG&country=CN&kpidate=2023-10-01&timerange=year
  getScoreMonthOrYear(apexId:string, month:string, driverCountry:string, driverBusinessType:string, timerange:string): Observable<any[]> {
    
    // let url=`${environment.api.uri}v1.0/coaching`;
    let url=`${environment.api.uri}v1.0/score?apexid=${apexId}&kpidate=${month}&country=${driverCountry}&businesstype=${driverBusinessType}&timerange=${timerange}`;
    return this.http.get<any[]>(url);
  }


  // v1.0/score/economy?apexid=zhangw13&kpidate=2024-02
  getEconomyByApexIdAndMonth(apexId:string, month:string): Observable<any[]> {
    
    // let url=`${environment.api.uri}v1.0/coaching`;
    let url=`${environment.api.uri}v1.0/score/economy?apexid=${apexId}&kpidate=${month}`;
    return this.http.get<any[]>(url);
  }
  
  // v1.0/score/economy?apexid=zhangw13&kpidate=2023-10-01&kpidate=2024-03-31&businesstype=PG&country=CN&timerange=year
  // v1.0/score/economy?apexid=zhangw13&kpidate=2024-02-01&businesstype=PG&country=CN&timerange=month
  getEconomyMonthOrYear(apexId:string, startMonth:string, driverCountry:string, driverBusinessType:string, timerange:string, endMonth:string): Observable<any[]> {
    
    // let url=`${environment.api.uri}v1.0/coaching`;
    let url=`${environment.api.uri}v1.0/score/economy?apexid=${apexId}&kpidate=${startMonth}&country=${driverCountry}&businesstype=${driverBusinessType}&timerange=${timerange}`;
    // &kpidate=${month}
    if(timerange === 'year'){
      url = url + `&kpidate=${endMonth}`;
    }
    return this.http.get<any[]>(url);
  }

}
